import { LoggerHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { BaseStateSessionInfo } from '@store';

type SessionStorageKeys = 'contextId' | 'ott' | 'state' | 'returnUrl' | 'tokenOAuth' | 'mseOTT' | 'languageCode';

const store = {
	contextId: '',
	ott: '',
	state: '',
	returnUrl: '',
	tokenOAuth: '',
	mseOTT: '',
	languageCode: '',
};
export const getSessionInfo = (encodedSessionInfo?: string): BaseStateSessionInfo => {
	LoggerHelper.log('SessionInfo', 'getSessionInfo > encodedSessionInfo', encodedSessionInfo);

	const decodedSessionInfo = encodedSessionInfo ? decodeURI(encodedSessionInfo) : null;

	LoggerHelper.log('SessionInfo', 'getSessionInfo > decodedSessionInfo', decodedSessionInfo);

	return decodedSessionInfo ? JSON.parse(decodedSessionInfo) : null;
};

export const getSavedTokenDataFromStorage = <TOutput>(key: SessionStorageKeys): TOutput | undefined => {
	try {
		return store[key] as TOutput;
	} catch (err) {
		return undefined;
	}
};

export const saveTokenDataFromStorage = <TInput>(key: SessionStorageKeys, value: TInput): void => {
	try {
		store[key] = value as string;
	} catch (err) {}
};
